import { Color } from "../../../core/models/entities/LogoOptions";
import { useTranslation } from "react-i18next";
import ColorBlockWithToolTip from "../../screens/logo-editor/componenets/ColorBlockWithToolTip";
import { systemColorDisplayName } from "../../../utils/systemColors";

interface Props {
  color: Color;
  showName?: boolean;
  maxWidth?: string;
  // True when the surrounding logo's transfer method is embroidery — backup
  // rows then show their own name (e.g. "TONE I TONE") instead of "Backup
  // White" (owner decision 31/8). The bordered backup swatch is unchanged.
  embroideryMethod?: boolean;
}

export function VectorColorElement({
  color,
  showName,
  maxWidth = "max-w-16",
  embroideryMethod,
}: Props) {
  const { t } = useTranslation();
  return (
    <div className={"flex align-middle space-x-1"}>
      <ColorBlockWithToolTip
        onClick={() => {}}
        size={"sm"}
        color={color}
        embroideryMethod={embroideryMethod}
      />
      {showName && (
        <span className={`truncate ${maxWidth}`}>
          {/* Same strings as the old compLogoDesign.color* keys in all 10
              locales — centralized via the shared system-color utility. */}
          {systemColorDisplayName(color, t, { embroideryMethod }) ?? color.name}
        </span>
      )}
    </div>
  );
}
